import { render } from "./AppHeading.vue?vue&type=template&id=e6b72800"
const script = {}

import "./AppHeading.vue?vue&type=style&index=0&id=e6b72800&lang=css"
script.render = render

export default script